import {css} from "@pandacss/css";
import {createPandaComponent} from "../helpers/pandaComponent.ts";
import {font} from "../style/typography.tsx";

const badgeClass = css({
    padding: "8px 16px",
    borderRadius: "18px",
    gap: "8px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "neutral.600",
    border: "1px solid",
    borderColor: "neutral.400",
    color: "neutral.100",
    minHeight: "36px"
})

const Badge = createPandaComponent('Badge', 'div', [badgeClass, font("body", "2", "semiBold")]);

export default Badge;